import { defineNuxtPlugin } from '#app';
import { useOffCanvas } from '~/composables/useOffCanvas.js';
import { markRaw } from 'vue';

export default defineNuxtPlugin(nuxtApp => {
    function legacyShowOffCanvas(options) {
        const oc = useOffCanvas();

        oc.show({
            component: markRaw(options.component),
            title: options.title,
            width: options.width,
            props: options.props || {}
        });
    }

    nuxtApp.provide('showOffCanvas', legacyShowOffCanvas);
    nuxtApp.provide('$showOffCanvas', legacyShowOffCanvas);
});
